import React, { forwardRef } from "react";
import { IoHelpCircle } from "react-icons/io5";
import { RiCustomerService2Line } from "react-icons/ri";
import { Link } from "react-router-dom";

const Header = forwardRef((props, ref) => {
  const gotoBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  return (
    <div
      ref={ref}
      className="bg-black text-white h-[2.5rem] flex items-center shadow-sm"
    >
      <div className="container flex items-center justify-between px-4 mx-auto">
        {/* Customer Care Link */}
        <a
          href="https://wa.me/9803411049"
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 text-sm transition-colors duration-200 hover:text-amber-400"
        >
          <RiCustomerService2Line className="text-lg" />
          <span>Customer Care</span>
        </a>

        {/* Become a Member Link */}
        <Link
          to="/register"
          className="items-center hidden gap-2 text-sm transition-colors duration-200 md:flex hover:text-amber-400"
        >
          <span className="font-medium">Become a member today</span>
          <span className="text-amber-400">and get exciting offers!</span>
        </Link>

        {/* Help Button */}
        <button
          onClick={gotoBottom}
          className="flex items-center gap-2 text-sm transition-colors duration-200 hover:text-amber-400"
        >
          <IoHelpCircle className="text-lg" />
          <span>Help</span>
        </button>
      </div>
    </div>
  );
});

export default Header;
